import React from 'react';
import {
  DestinationMap,
  DestinationName,
  DestinationVariant,
  InferContextValueFromDestinationModel
} from '../../types';
import { useComponentsForDestination } from './useComponentsForDestination';

interface PluginDestinationProps<
  N extends DestinationName,
  T extends InferContextValueFromDestinationModel<DestinationMap[N]>
> {
  name: N;
  contextValue?: T;
  variant?: DestinationVariant;
  wrapper?: React.ComponentType<{ children: React.ReactNode }>;
  children?: React.ReactNode;
}

export const PluginDestination = <
  N extends DestinationName,
  T extends InferContextValueFromDestinationModel<DestinationMap[N]>
>({
  name,
  children,
  variant,
  contextValue,
  wrapper
}: PluginDestinationProps<N, T>) => {
  const result = useComponentsForDestination(name, children, contextValue, variant);
  if (!result.length) return null;
  const Wrapper = wrapper ?? React.Fragment;
  const key = `${name}${variant ?? ''}`;
  return <Wrapper key={key} children={result} />;
};
